<template>
<section class="layout-content-wrapper" :class="{'has-filter':$slots.filter!==undefined, 'has-footer':$slots.footer!==undefined}">
  <header class="layout-content-header">
    <section class="layout-content-toolbar">
      <slot v-if="$slots.headerTitle" name="headerTitle" />
      <h1 v-else class="layout-content-header-text">{{title || $route.meta.label}}</h1>
      <section class="toolbar">
        <slot name="toolbar" />
      </section>
    </section>
    <section v-if="$slots.filter" class="layout-content-header-filter">
      <section class="filter-wrapper">
        <slot name="filter" />
      </section>
    </section>
  </header>
  <section class="layout-content-body">
    <section class="layout-content-body-inner">
      <slot name="body" />
    </section>
  </section>
  <footer v-if="$slots.footer" class="layout-content-footer">
    <slot name="footer" />
  </footer>

  <slot name="editor" />
</section>
</template>

<script>
export default {
  name: 'LayoutContent',
  props: {
    title: String
  }
}
</script>

<style lang="scss">
.layout-content-wrapper {
  position: relative;
  min-width: 47em;
  width: 100%;
  height: 100%;
  padding-top: 2.8em;
  background-color: #ffffff;
  /*background: radial-gradient(ellipse at center, #29387d 0%, #1a234f 100%);*/
  -webkit-font-smoothing: antialiased;
  overflow: auto;

  &.has-filter {
    padding-top: 5.2em;
  }

  $FOOTER-HEIGHT: 44px;
  $PADDING-LEFT-RIGHT: .8em;

  &.has-footer {
    padding-bottom: $FOOTER-HEIGHT;

    .layout-content-footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: $FOOTER-HEIGHT;
      padding: 0 $PADDING-LEFT-RIGHT 12px;
    }
  }

  .layout-content-header {
    position: absolute;
    top: .8em;
    left: 0;
    width: 100%;
    padding: 0 $PADDING-LEFT-RIGHT;

    .layout-content-toolbar {
      height: 2em;

      .layout-content-header-text {
        font-size: 1.25em;
        float: left;
        line-height: 1.6;
        margin: 0;
      }

      /deep/ .toolbar-btn {
        line-height: 0;
      }
    }

    .toolbar {
      display: flex;
      align-items: center;
      gap: 6px;
      float: right;
    }

    .layout-content-header-filter {
      margin-top: .8em;
      height: 2em;

      .filter-wrapper {
        font-size: .7em;
        height: 100%;
      }
    }
  }

  .layout-content-body {
    width: 100%;
    height: 100%;
    padding: 1em 0 0;

    .layout-content-body-inner {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Content.vue